/**
 * Tiny formatting helpers shared across pages. Kept dependency-free on
 * purpose — `Intl.DateTimeFormat` covers everything we need.
 */

export const fmtNum = (n: number | null | undefined): string => {
  if (n == null || !Number.isFinite(n)) return "0";
  return n.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const fmtMs = (n: number | null | undefined): string => {
  if (n == null || !Number.isFinite(n)) return "—";
  if (n < 1) return "<1ms";
  if (n >= 1000) return `${(n / 1000).toFixed(2)}s`;
  return `${Math.round(n)}ms`;
};

export const fmtPct = (n: number | null | undefined, digits = 1): string => {
  if (n == null || !Number.isFinite(n)) return "—";
  return `${n.toFixed(digits)}%`;
};

const dateFmt = new Intl.DateTimeFormat("en-IN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export const fmtDate = (d: string | Date | null | undefined): string => {
  if (!d) return "—";
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return "—";
  return dateFmt.format(date).replace(",", "");
};

export const fmtRelative = (d: Date | null | undefined): string => {
  if (!d) return "—";
  const diff = Math.round((Date.now() - d.getTime()) / 1000);
  if (diff < 5) return "just now";
  if (diff < 60) return `${diff}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const cls = (...parts: Array<string | false | null | undefined>) =>
  parts.filter(Boolean).join(" ");
